<template>
  <div class="intelligentAgriculture-page szxc">
    <!-- 数字乡村-->
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    	<div class="main">
            <div class="top-banner">
                <img style="width:100%;height:auto" src="../../assets/img/caseDetails/shuzixiangcun/banner.png">            
            </div>
            <div class="mid-body"  style="background:rgba(246,247,250,1);margin-bottom: 0;padding-top: 40px;">
                <div class="mid-body-box">
                    <h2 style="text-align: left;margin-bottom: 10px;margin-top: 80px;font-size: 38px;font-weight: 500;">百倍云数字乡村解决方案</h2>

                    <div>
                        <div class="left-box">
                            <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/shuzixiangcun/index01.png">    
                         </div>
                        <div class="left-box">
                            <p style="margin-bottom: 20px;font-size: 24px;font-weight: 700;margin-top: 8px;">方案概述</p>
                            <p style="    font-size: 16px;
    letter-spacing: 2px;
    color: #666;
    line-height: 24px;">党的十九大提出实施乡村振兴战略，是对“三农”工作作出的重大决策部署，是决胜
全面建成小康社会、全面建设社会主义现代化国家的重大历史任务，是新时代做好
“三农”工作的总抓手。百倍云数字乡村大数据综合管理平台从农村管理、农民管理、
产业管理、乡村综合治理、安全生产、经济状况监测、大数据分析方面进行规划，
针对三农管理工作中实际业务需求定制开发内容，可灵活配置功能模块，实现三农
管理工作信息化、公开化、便民化。</p>
                        </div>
                    </div>
                </div>    
            </div> 

            <div class="mid-body">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 10px;margin-top: 80px;font-size: 32px;font-weight: 500;">国家政策要求</h2>
                    <div>
                        <div class="five-box" @click="clicknav(1)">
                            <img v-if="select == 1" src="../../assets/img/caseDetails/shuzixiangcun/index1_on.png"> 
                            <img v-else  src="../../assets/img/caseDetails/shuzixiangcun/index1_off.png"> 
                            <span :class="{'active':select==1}"  >产业兴旺</span>   
                        </div>
                        <div class="five-box" @click="clicknav(2)">
                            <img v-if="select == 2"  src="../../assets/img/caseDetails/shuzixiangcun/index2_on.png"> 
                            <img v-else  src="../../assets/img/caseDetails/shuzixiangcun/index2_off.png">   
                            <span :class="{'active':select==2}"  >生态宜居</span>  
                        </div>
                        <div class="five-box" @click="clicknav(3)">
                            <img v-if="select == 3"  src="../../assets/img/caseDetails/shuzixiangcun/index3_on.png"> 
                            <img v-else  src="../../assets/img/caseDetails/shuzixiangcun/index3_off.png">    
                            <span :class="{'active':select==3}"  >乡风文明</span>  
                        </div>
                        <div class="five-box" @click="clicknav(4)">
                            <img v-if="select == 4"  src="../../assets/img/caseDetails/shuzixiangcun/index4_on.png"> 
                            <img v-else src="../../assets/img/caseDetails/shuzixiangcun/index4_off.png"> 
                            <span :class="{'active':select==4}"  >治理有效</span>  
                        </div>
                        <div class="five-box" @click="clicknav(5)">
                            <img v-if="select == 5" src="../../assets/img/caseDetails/shuzixiangcun/index5_on.png"> 
                            <img v-else src="../../assets/img/caseDetails/shuzixiangcun/index5_off.png"> 
                            <i v-if="select == 5" class="select-on"></i>   
                            <span :class="{'active':select==5}"  >生活富裕</span>    
                        </div>
                        
                    </div>
                    <div class="nav-box">
                        <div  v-if="select == 1">
                            <div class="list">
                                <div class="list-item">物联网系统</div>
                                <div class="list-item">大田种植</div>
                                <div class="list-item">设施园艺</div>
                                <div class="list-item">水产养殖</div>
                                <div class="list-item">畜禽养殖</div>
                            </div>
                            <div class="list">
                                <div class="list-item">农业机械化</div>
                                <div class="list-item">智能农机</div>
                                <div class="list-item">农业AI机器人</div>
                                <div class="list-item">智能灌溉</div>
                            </div>    
                            <div class="list">
                                <div class="list-item">可视化溯源</div>
                                <div class="list-item">农业品牌电商</div>
                                <div class="list-item">市场信息服务</div>
                                <div class="list-item">ERP系统</div>
                                <div class="list-item">标准化生产指导</div>
                                <div class="list-item">植保服务</div>
                                <div class="list-item">农业全产业专家系统</div>
                            </div> 
                             <div class="list">
                                <div class="list-item">乡村文旅</div>
                                <div class="list-item" v-if="shownav">金融保险</div>
                            </div> 
                        </div>    





                         <div  v-if="select == 2">
                            <div class="list">
                                <div class="list-item">山</div>
                                <div class="list-item">水</div>
                                <div class="list-item">林</div>
                                <div class="list-item">田</div>
                                <div class="list-item">湖</div>
                                <div class="list-item">草</div>
                            </div>
                            <div class="list">
                                <div class="list-item">位置</div>
                                <div class="list-item">性质</div>
                                <div class="list-item">分类</div>
                                <div class="list-item">用途</div>
                                <div class="list-item">气候</div>
                                <div class="list-item">形态特征</div>
                                <div class="list-item">土壤内容</div>
                            </div>    
                            <div class="list">
                                <div class="list-item">规划状态</div>
                                <div class="list-item">耕地利用状态</div>
                                <div class="list-item">使用状态</div>
                            </div> 
                        </div>   

                        <div  v-if="select == 3">
                            <div class="list">
                                <div class="list-item">乡村要闻</div>
                                <div class="list-item">文明实践</div>
                                <div class="list-item">普法宣传</div>
                                <div class="list-item">名人名事</div>
                                <div class="list-item">村规民约</div>
                                <div class="list-item">善行义举</div>
                                <div class="list-item">信用乡村管理</div>
                            </div>
                        </div>   

                          <div  v-if="select == 4">



                            <div class="list">
                                <div class="list-item" v-if="shownav">政策管理</div>
                                <div class="list-item" v-if="shownav">智慧党建</div>
                                <div class="list-item">智慧交通</div>
                                <div class="list-item">智慧能源</div>
                                <div class="list-item">智慧水利</div>
                                <div class="list-item">远程视频监控</div>
                                <div class="list-item">乡村环境全时监控</div>
                            </div>
                             <div class="list">
                                <div class="list-item">网格化治理</div>
                                <div class="list-item">垃圾分类</div>
                                <div class="list-item">阳光扶贫系统</div>
                                <div class="list-item" v-if="shownav">产权交易系统</div>
                                <div class="list-item" v-if="shownav">产业执法系统</div>
                                <div class="list-item">自然灾害监测</div>
                                <div class="list-item">森林水灾</div>
                                <div class="list-item">防汛抗旱</div>
                            </div>
                        </div>   


                          <div  v-if="select == 5">


                            <div class="list">
                                <div class="list-item">政策民生</div>
                                <div class="list-item">经济民生</div>
                                <div class="list-item">生态民生</div>
                                <div class="list-item">文化民生</div>
                                <div class="list-item">社会民生</div>
                            </div>
                             <div class="list">
                                <!-- <div class="list-item">医疗卫生</div> -->
                                <div class="list-item">养老</div>
                                <div class="list-item">教育</div>
                                <div class="list-item">社会保障</div>
                                <div class="list-item">体育健身</div>
                                <!-- <div class="list-item">社会保险</div> -->
                                <div class="list-item">其他服务</div>
                            </div>
                        </div>   
                    </div>    
                </div>    
            </div> 

            <div class="mid-body" style="background:rgba(246,247,250,1);margin-bottom: 0;padding-top: 30px;padding-bottom: 60px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 80px;font-size: 32px;font-weight: 500;">百倍云数字乡村解决方案</h2>
                    <div>   
                        <p style="margin-bottom: 40px;font-size: 16px;font-weight: 500;margin-top: 36px;color:#666">百倍云数字乡村项目将对应用系统建设结构、数据模型结构、数据存储结构以及系统扩展规划等内容进行统筹规划和统一设计，打造一条无障碍的农村信息服务高速通道。
针对现有的三农资源，以“实用、管用、有用”为原则，以“高效、规范、科学”为目的，实现管理运作规范化、自动化、程序化、简便化。系统包含农村管理、农民管理、乡
镇工作管理、综合治理、经济状况管理等应用以及其它定制化应用，建立可见的、实践性强的、涉农企业和农户满意的农村信息化服务体系，形成政府或经营性单位提供面向
三农的专业化的服务机制和示范效应。</p>                                                                       
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/shuzixiangcun/index02.png">                                             
                    </div>
                </div>    
            </div> 
             <!-- <div class="mid-body">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 80px;font-size: 32px;font-weight: 500;">数字乡村小程序</h2>
                    <div>                                                                    
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/shuzixiangcun/index03.png">   
                        <div style="width:345px;float:right;text-align:left">
                            <p style="font-size: 24px;">首页</p> 
                            <p style="margin-bottom: 20px;font-size: 16px;font-weight: 500;margin-top: 16px;color:#999">公共卫生、村务党务、疫情上报三大模块</p>        
                        </div>                       
                    </div>
                </div>    
            </div>  -->

         
            
            <div class="mid-body" style="position:relative;height:880px">
                <p class="szxc-title">基础治理</p>
                <img style="width:100%;height:auto;margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg2.png">    
                <div class="mid-body-box" style="position: absolute;top: 80px;left: 50%;margin-left: -600px;">   
                    <div>          
                        <img style="width:100%;height:auto; margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg1.png">                                   
                        <div class="three-box" style="padding: 10px 66px;text-align:center;padding-right: 150px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">垃圾智能分类</p>                      
                        </div>    
                        <div class="three-box" style="padding: 10px 66px;text-align:center"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">生态环境监测</p>
                        </div>  
                        <div class="three-box" style="padding: 10px 36px;text-align:center;padding-left: 125px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">车辆人流控制</p>
                        </div>
                              
                    </div>
                </div>    
            </div> 
            <div class="mid-body" style="position:relative;height:680px">
                <img style="width:100%;height:auto;margin-top: 240px;" src="../../assets/img/caseDetails/shuzixiangcun/bg2.png">    
                <div class="mid-body-box" style="position: absolute;top: -160px;left: 50%;margin-left: -600px;">   
                    <div>          
                        <img style="width:100%;height:auto; margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg3.png">                                   
                         <div class="three-box" style="padding: 10px 66px;text-align:center;padding-right: 150px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">农村饮水安全</p>
                        </div>    
                        <div class="three-box" style="padding: 10px 66px;text-align:center"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">自然灾害监测</p>
                        </div>  
                        <div class="three-box" style="padding: 10px 36px;text-align:center;padding-left: 125px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">村民积分</p>
                        </div>
                              
                    </div>
                </div>    
            </div> 

            <div class="mid-body" style="position:relative;height:880px">
                <p class="szxc-title">村务党建</p>
                <img style="width:100%;height:auto;margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg5.png">    
                <div class="mid-body-box" style="position: absolute;top: 80px;left: 50%;margin-left: -600px;">   
                    <div>          
                        <img style="width:100%;height:auto; margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg4.png">                                   
                        <div class="three-box" style="padding: 10px 66px;text-align:center;padding-right: 150px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">智慧党建</p>                      
                        </div>    
                        <div class="three-box" style="padding: 10px 66px;text-align:center"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">网上议事</p>
                        </div>  
                        <div class="three-box" style="padding: 10px 36px;text-align:center;padding-left: 125px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">组织投票</p>
                        </div>
                              
                    </div>
                </div>    
            </div> 
            <div class="mid-body" style="position:relative;height:680px">
                <img style="width:100%;height:auto;margin-top: 240px;" src="../../assets/img/caseDetails/shuzixiangcun/bg5.png">    
                <div class="mid-body-box" style="position: absolute;top: -160px;left: 50%;margin-left: -600px;">   
                    <div>          
                        <img style="width:100%;height:auto; margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg6.png">                                   
                         <div class="three-box" style="padding: 10px 66px;text-align:center;padding-right: 150px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">网格管理</p>
                        </div>    
                        <div class="three-box" style="padding: 10px 66px;text-align:center"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">事件上报</p>
                        </div>  
                        <div class="three-box" style="padding: 10px 36px;text-align:center;padding-left: 125px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">人口管理</p>
                        </div>
                              
                    </div>
                </div>    
            </div> 


            <div class="mid-body" style="position:relative;height:880px">
                <p class="szxc-title">服务民生</p>
                <img style="width:100%;height:auto;margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg8.png">    
                <div class="mid-body-box" style="position: absolute;top: 80px;left: 50%;margin-left: -600px;">   
                    <div>          
                        <img style="width:100%;height:auto; margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg7.png">                                   
                        <div class="three-box" style="padding: 10px 66px;text-align:center;padding-right: 150px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">智慧养老</p>                      
                        </div>    
                        <div class="three-box" style="padding: 10px 66px;text-align:center"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">便民交通</p>
                        </div>  
                        <div class="three-box" style="padding: 10px 36px;text-align:center;padding-left: 125px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">法律咨询</p>
                        </div>
                              
                    </div>
                </div>    
            </div> 
            <div class="mid-body" style="position:relative;height:680px">
                <img style="width:100%;height:auto;margin-top: 240px;" src="../../assets/img/caseDetails/shuzixiangcun/bg8.png">    
                <div class="mid-body-box" style="position: absolute;top: -160px;left: 50%;margin-left: -600px;">   
                    <div>          
                        <img style="width:100%;height:auto; margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg9.png">                                   
                         <div class="three-box" style="padding: 10px 66px;text-align:center;padding-right: 150px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">退伍军人</p>
                        </div>    
                        <div class="three-box" style="padding: 10px 66px;text-align:center"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">本地就业</p>
                        </div>  
                        <div class="three-box" style="padding: 10px 36px;text-align:center;padding-left: 125px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">在线培训</p>
                        </div>
                              
                    </div>
                </div>    
            </div> 

             <div class="mid-body" style="position:relative;height:880px">
                <p class="szxc-title">数字农业</p>
                <img style="width:100%;height:auto;margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg11.png">    
                <div class="mid-body-box" style="position: absolute;top: 80px;left: 50%;margin-left: -600px;">   
                    <div>          
                        <img style="width:100%;height:auto; margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg10.png">                                   
                        <div class="three-box" style="padding: 10px 66px;text-align:center;padding-right: 150px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">大棚农业</p>                      
                        </div>    
                        <div class="three-box" style="padding: 10px 66px;text-align:center"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">大田农业</p>
                        </div>  
                        <div class="three-box" style="padding: 10px 36px;text-align:center;padding-left: 125px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">数字渔场</p>
                        </div>
                              
                    </div>
                </div>    
            </div> 
            <div class="mid-body" style="position:relative;height:680px">
                <img style="width:100%;height:auto;margin-top: 240px;" src="../../assets/img/caseDetails/shuzixiangcun/bg11.png">    
                <div class="mid-body-box" style="position: absolute;top: -160px;left: 50%;margin-left: -600px;">   
                    <div>          
                        <img style="width:100%;height:auto; margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg12.png">                                   
                         <div class="three-box" style="padding: 10px 66px;text-align:center;padding-right: 150px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">肥药两制</p>
                        </div>    
                        <div class="three-box" style="padding: 10px 66px;text-align:center"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">农事农资</p>
                        </div>  
                        <div class="three-box" style="padding: 10px 36px;text-align:center;padding-left: 125px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">智能种植</p>
                        </div>
                              
                    </div>
                </div>    
            </div> 


             <div class="mid-body" style="position:relative;height:880px">
                <p class="szxc-title">农旅融合</p>
                <img style="width:100%;height:auto;margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg14.png">    
                <div class="mid-body-box" style="position: absolute;top: 80px;left: 50%;margin-left: -600px;">   
                    <div>          
                        <img style="width:100%;height:auto; margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg13.png">                                   
                        <div class="three-box" style="padding: 10px 66px;text-align:center;padding-right: 150px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">智慧旅游</p>                      
                        </div>    
                        <div class="three-box" style="padding: 10px 66px;text-align:center"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">电子导览</p>
                        </div>  
                        <div class="three-box" style="padding: 10px 36px;text-align:center;padding-left: 125px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">周边民宿</p>
                        </div>
                              
                    </div>
                </div>    
            </div> 
            <div class="mid-body" style="position:relative;height:680px">
                <img style="width:100%;height:auto;margin-top: 240px;" src="../../assets/img/caseDetails/shuzixiangcun/bg14.png">    
                <div class="mid-body-box" style="position: absolute;top: -160px;left: 50%;margin-left: -600px;">   
                    <div>          
                        <img style="width:100%;height:auto; margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg15.png">                                   
                         <div class="three-box" style="padding: 10px 66px;text-align:center;padding-right: 150px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">游玩套餐</p>
                        </div>    
                        <div class="three-box" style="padding: 10px 66px;text-align:center"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">特色产业园</p>
                        </div>  
                        <div class="three-box" style="padding: 10px 36px;text-align:center;padding-left: 125px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">农产品溯源</p>
                        </div>
                              
                    </div>
                </div>    
            </div> 


             <div class="mid-body" style="position:relative;height:880px">
                <p class="szxc-title">N个场景</p>
                <img style="width:100%;height:auto;margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg17.png">    
                <div class="mid-body-box" style="position: absolute;top: 80px;left: 50%;margin-left: -600px;">   
                    <div>          
                        <img style="width:100%;height:auto; margin-top: 80px;" src="../../assets/img/caseDetails/shuzixiangcun/bg16.png">                                   
                        <div class="three-box" style="padding: 10px 66px;text-align:center;padding-right: 150px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">新农人</p>                      
                        </div>    
                        <div class="three-box" style="padding: 10px 66px;text-align:center"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">农产品品牌</p>
                        </div>  
                        <div class="three-box" style="padding: 10px 36px;text-align:center;padding-left: 125px;"> 
                            <p style="margin-bottom: 20px;font-size: 26px;font-weight: 700;margin-top: 36px;">农村电商</p>
                        </div>
                              
                    </div>
                </div>    
            </div> 

                   
            
        
		</div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'intelligentAgriculture',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {
        shownav:false,
        select:1,
    }
  },
  mounted() {
      this.changetitle()
  },
  methods: {
      clicknav(e){
          this.select = e
      },
          changetitle(){//http://www.100byun.com  http://100byun.com使用这个域名访问官网时，底部的备案信息需要更换下，其它访问方式时，底部备案信息还是跟当前一样不变
    var url = window.location.href
     this.shownav = true
    // if(url.split("/#/")[0] == "http://www.100byun.com"||url.split("/#/")[0] == "http://100byun.com"){
    //   this.shownav = false
    // }else{
    //   this.shownav = true
        
    // }
    },
  }
}
</script>
<style>
 .banner-title{
        width: 490px;
        height: 120px;
        position: absolute;
        top: 50%;
        right: 50%;
        margin-top: 40px;
    }
    .mid-body{
        margin-bottom: 120px;
    }
    .mid-body-box{
        width: 1200px;
        margin: auto;
        position: relative;
    }
    .four-box{
        width: 25%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
    }
    .list-box{
     box-sizing: border-box;
    padding: 20px;
    position: relative;
    text-align: left;
    padding-left: 240px;
        
    }
    .list-box img{
        width: 24px;
        height: auto;
        position: absolute;
        left: 190px;
        top: 21px;
    }
     .list-box p{
        margin-bottom: 14px;
    }
    .five-box{
        width: 20%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
        padding-bottom: 0;
    }
    .five-box img{
            width: 50px;
    height: auto;
    margin: auto;
    cursor: pointer;
    }
        .five-box span{
         display: inline-block;
        padding-top: 22px;
        padding-bottom: 32px;
        font-size: 18px;
        font-weight: bold;
        color: #8993a7;
        line-height: 1em;
        border-bottom: 3px solid transparent;
        cursor: pointer;
    }
   
    .szxc .three-box{
        width: 33% !important;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
    }
    .left-box{
        width: 50%;
        float: left;
        text-align: left;
        box-sizing: border-box;
        padding: 74px;
    }
    .nav-box{
        width: 100%;
        border: 1px solid #dbe0e5;
        box-sizing: border-box;
        padding: 40px;
    }
    .nav-box .list{
        width: 100%;
        margin-bottom: 20px;
        text-align: left;
    }
    .list-item{
        padding: 12px 20px;
        color: #8993a7;
        margin-right: 20px;
        margin-bottom: 20px;
        display: inline-block;
        background: #ffffff;
        border: 1px solid #d0d7e1;
        -webkit-box-shadow: 0px 3px 7px 0px rgba(189, 230, 202, 0.35);
        box-shadow: 0px 3px 7px 0px rgba(189, 230, 202, 0.35);
        min-width: 120px;
        text-align: center;
        position: relative;
            font-size: 12px;
    width: 150px;
    }
    .img_index03{
        width:223px;
        height:auto;
        position:absolute;
        right: 405px;
        top: 97px;
        z-index: 2;
    }

    .img_index04{
        width: auto;
        height: 94%;
        position: absolute;
        top: 0;
        right: 65%;
        margin-top: 1%;
    }
        .img_index06{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: 97px;
        z-index: 2;
    }
    .img_index07{
    width: 223px;
    height: auto;
    position: absolute;
    left: 165px;
    top: 229px;
    z-index: 2;
    }
    .img_index09{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: -205px;
        z-index: 2;
    }
    .active{
        border-bottom: 3px solid #f8a811 !important;
        color: #333 !important;
    }
    .szxc-title{
        width: 1200px;
    margin: auto;
    line-height: 137px;
    text-align: left;
    padding-left: 25px;
    font-size: 30px;
    font-weight: 500;
        padding-top: 20px;
    }

</style>